import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import CATEGORY from '../../constants/category'

interface Props {
  clickAppCallback?: (name: string) => void
  clickFabCallback?: (name: string) => void
  list: {
    category_id: number
    company_service_name: string | null
    name: string
    use_rate: number
    use_count: number
    icon: string | null,
    color: string | null,
    favorite: boolean,
  }[]
}

const ApplicationCardList: FC<Props> = (props) => {
  const {
    clickAppCallback,
    clickFabCallback,
    list,
  } = props

  return (
    <div className="application_card_frame">
      {
        list.map((value) => (
          <div
            className="application_card_wrap"
            key={`application_card_${value.name}`}
          >
            <div
              className="application_card"
              // eslint-disable-next-line max-len
              onClick={clickAppCallback ? () => clickAppCallback(value.name) : undefined}
              role="none"
            >
              <div className="icon_area">
                {
                  value.icon ? (
                    <i
                      className={value.icon}
                      style={{
                        color: value.color || "",
                      }}
                    />
                  ) : (
                    <i
                      className="fas fa-question"
                      style={{
                        color: "#CCCCCC",
                      }}
                    />
                  )
                }
              </div>
              <div className="detail_area">
                <div
                  className="category_title"
                  style={{
                    backgroundColor: CATEGORY.find((val) => val.id === value.category_id)?.bg_color,
                  }}
                >
                  <span
                    style={{
                      color: CATEGORY.find((val) => val.id === value.category_id)?.bg_color,
                    }}
                  >
                    {CATEGORY.find((val) => val.id === value.category_id)?.title}
                  </span>
                </div>
                <div className="application_title">
                  {value.company_service_name ? `${value.company_service_name}(${value.name})` : value.name}
                </div>
                <div className="detail_row">
                  <div>
                    利用時間割合
                  </div>
                  <div className="value">
                    <span>
                      {value.use_rate}
                    </span>
                    %
                  </div>
                </div>
                <div className="detail_row">
                  <div>
                    利用人数
                  </div>
                  <div className="value">
                    <span>
                      {value.use_count.toLocaleString()}
                    </span>
                    人
                  </div>
                </div>
              </div>
            </div>
            {
              !!clickFabCallback && (
                <button
                  className={`favorite ${value.favorite ? "on" : "off"}`}
                  type="button"
                  onClick={() => clickFabCallback(value.name)}
                >
                  <FontAwesomeIcon icon={['fas', 'thumbtack']} rotate={45} />
                </button>
              )
            }
          </div>
        ))
      }
    </div>
  )
}

ApplicationCardList.defaultProps = {
  clickAppCallback: undefined,
  clickFabCallback: undefined,
}

export default ApplicationCardList
